import { useState, useEffect, useCallback } from 'react';
import { getOperationTypes, OperationTypeDto } from '../services/OperationTypeService';

export const useOperationTypes = () => {
  const [operationTypes, setOperationTypes] = useState<OperationTypeDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchOperationTypes = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getOperationTypes();
      if (response.success && Array.isArray(response.data)) {
        setOperationTypes(response.data as OperationTypeDto[]);
      } else {
        const msg =
          typeof response.message === 'string' ? response.message : 'Error al cargar tipos de operación';
        setError(msg);
        setOperationTypes([]);
      }
    } catch {
      setError('Error al cargar tipos de operación');
      setOperationTypes([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchOperationTypes();
  }, [fetchOperationTypes]);

  return { operationTypes, isLoading, error };
};
